import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, Activity, Target, Timer, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import silhouette from '../../assets/silhouette.png';

export default function PlayerOfTheMonth() {
  // Mock data
  const player = {
    name: "Thomas DE PARMENTIER",
    position: "Attaquant",
    number: "9",
    stats: {
      matches: 4,
      goals: 5,
      assists: 2,
      minutes: 360
    },
    image: silhouette
  };

  return (
    <section className="w-full py-12 relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="relative overflow-hidden border border-white/10 rounded-2xl p-6 bg-white/10 backdrop-blur-sm">

          {/* Background Elements */}
          <div className="absolute top-0 right-0 w-2/3 h-full opacity-90 z-0 hidden md:block" />
          <div className="absolute inset-0 bg-efafcDark md:hidden z-0" />

          <div className="relative z-10 flex flex-col md:flex-row items-center">

            {/* Image Section */}
            <div className="w-full md:w-1/3 lg:w-1/4 h-64 md:h-auto relative flex justify-center items-end pt-8 bg-gradient-to-b from-gray-100 to-white md:bg-none">
              <motion.img
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                src={player.image}
                alt={player.name}
                className="h-full max-h-[350px] object-contain relative z-10 drop-shadow-2xl"
              />
              {/* Circle behind player */}
              <div className="absolute bottom-0 w-48 h-48 bg-efafcYellow/20 rounded-full blur-2xl z-0" />
            </div>

            {/* Content Section */}
            <div className="flex-1 p-8 md:p-12 text-white">
              <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-8">
                <div>
                  <div className="inline-flex items-center gap-2 px-3 py-1 bg-efafcYellow text-efafcDark rounded-full font-bold text-xs mb-3 tracking-wider">
                    <Trophy size={14} />
                    JOUEUR DU MOIS
                  </div>
                  <h2 className="text-3xl md:text-4xl font-title font-bold text-white mb-1">
                    {player.name}
                  </h2>
                  <p className="text-lg text-efafcYellow font-accent font-semibold">
                    {player.position} • N°{player.number}
                  </p>
                </div>

                <Link to="/equipes">
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="hidden lg:flex items-center gap-2 px-6 py-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/20 rounded-xl text-white font-bold transition-all"
                  >
                    Voir l'effectif
                    <ArrowRight size={18} />
                  </motion.button>
                </Link>
              </div>

              {/* Stats Grid */}
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                {[
                  { label: 'Matchs', value: player.stats.matches, icon: Activity },
                  { label: 'Buts', value: player.stats.goals, icon: Target },
                  { label: 'Passes D.', value: player.stats.assists, icon: Target },
                  { label: 'Minutes', value: player.stats.minutes, icon: Timer },
                ].map((stat, index) => (
                  <motion.div
                    key={stat.label}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.1 }}
                    className="bg-white/5 backdrop-blur-sm border border-white/10 p-4 rounded-xl hover:bg-white/10 transition-colors group"
                  >
                    <div className="flex items-center gap-2 mb-2 text-gray-400 text-sm font-medium">
                      <stat.icon size={16} className="text-efafcGreen group-hover:text-efafcYellow transition-colors" />
                      {stat.label}
                    </div>
                    <p className="text-3xl font-bold text-white font-title">{stat.value}</p>
                  </motion.div>
                ))}
              </div>

              <Link to="/equipes" className="lg:hidden mt-8 block">
                <button className="w-full py-3 bg-white/10 border border-white/20 rounded-xl text-white font-bold flex items-center justify-center gap-2">
                  Voir l'effectif
                  <ArrowRight size={18} />
                </button>
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}
